<template>
  <div class="app-container">
    <div class="screeBox">
      <el-select
        filterable
        class="screenInput"
        v-model="screen.park_id"
        placeholder="请选择园区"
        :disabled="userInfo.park_id != 0"
        @change="screenParkChange"
      >
        <el-option label="全部园区" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>
      <!-- <el-select
        filterable
        class="screenInput"
        v-model="screen.audit_user_id"
        placeholder="请选择审核人"
      >
        <el-option
          :label="item.username"
          :value="item.id"
          v-for="(item, index) in adminUserList"
          :key="index"
        ></el-option>
      </el-select> -->
      <el-select
        filterable
        style="margin-right: 10px"
        v-model="screen.user_id"
        placeholder="请选择认领用户"
        :disabled="screen.park_id == ''"
      >
        <el-option label="全部认领用户" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in userList"
          :key="index"
        ></el-option>
      </el-select>
      <el-select
        filterable
        class="screenInput"
        v-model="screen.audit_user_id"
        placeholder="请选择审核人"
      >
        <el-option
          :label="item.username"
          :value="item.id"
          v-for="(item, index) in adminUserList"
          :key="index"
        ></el-option>
      </el-select>
      <el-input
        class="screenInput"
        v-model="screen.name"
        placeholder="请输入申请时的名字"
      ></el-input>
      <el-input
        class="screenInput"
        v-model="screen.phone"
        placeholder="请输入申请时的手机号"
      ></el-input>
      <el-select
        filterable
        class="screenInput"
        v-model="screen.status"
        placeholder="请选择预约状态"
      >
        <el-option label="全部预约状态" value=""></el-option>
        <el-option
          :label="item.title"
          :value="item.id"
          v-for="(item, index) in statusList"
          :key="index"
        ></el-option>
      </el-select>
      <el-date-picker
        value-format="timestamp"
        format="yyyy-MM-dd"
        v-model="screen.audit_time"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>
      <el-button type="primary" @click="(screen.page = 1), fetchData()"
        >搜索</el-button
      >
      <el-button type="primary" plain @click="reset()">重置</el-button>
    </div>

    <el-table
      max-height="700"
      v-loading="listLoading"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="园区" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.park ? scope.row.park.name : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="场地" min-width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.garden">{{ scope.row.garden.title }}</span>
        </template>
      </el-table-column>
      <el-table-column label="申请人" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.name ? scope.row.name : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="申请人手机号" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.phone ? scope.row.phone : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="申请日期" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.create_time }}</span>
        </template>
      </el-table-column>
      <el-table-column label="审核人" min-width="120">
        <template slot-scope="scope">
          <span>{{
            scope.row.audit_user ? scope.row.audit_user.username : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="审核日期" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.audit_time }}</span>
        </template>
      </el-table-column>

      <el-table-column label="审核状态" align="center">
        <template slot-scope="scope">
          {{
            scope.row.status == 1
              ? "待审核"
              : scope.row.status == 2
              ? "审核通过"
              : scope.row.status == 3
              ? "审核失败"
              : ""
          }}
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="220" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="getInfo(scope.row.id)"
            v-if="roles.includes('/garden/apply_info')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="operation(scope.row.id, 2)"
            v-if="
              roles.includes('/garden/apply_audit') && scope.row.status == 1
            "
            >通过</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="operation(scope.row.id, 3)"
            v-if="
              roles.includes('/garden/apply_audit') && scope.row.status == 1
            "
            >取消</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>

    <el-drawer size="700px" title="查看" :visible.sync="drawer" direction="rtl">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="所属园区" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            disabled
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <div v-if="ruleForm.garden">
          <el-form-item label="场地标题" prop="title">
            <el-input
              disabled
              v-model="ruleForm.garden.title"
              placeholder="请输入标题"
            ></el-input>
          </el-form-item>
        </div>

        <div v-if="ruleForm.user">
          <el-form-item label="申请人姓名">
            <el-input v-model="ruleForm.name" disabled></el-input>
          </el-form-item>
          <el-form-item label="申请人手机号">
            <el-input
              maxlength="11"
              v-model="ruleForm.phone"
              disabled
            ></el-input>
          </el-form-item>
        </div>

        <el-form-item label="审核状态">
          <el-select disabled v-model="ruleForm.status">
            <el-option label="待审核" :value="1"></el-option>
            <el-option label="审核通过" :value="2"></el-option>
            <el-option label="审核失败" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <div>
          <el-form-item label="审核人">
            <el-select filterable v-model="ruleForm.audit_user_id" disabled>
              <el-option
                :label="item.username"
                :value="item.id"
                v-for="(item, index) in adminUserList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审核时间">
            <el-input
              disabled
              v-model="ruleForm.audit_time"
              placeholder="请输入标题"
            ></el-input>
          </el-form-item>
        </div>
        <div v-if="ruleForm.place">
          <el-form-item label="租金价格" prop="price">
            <el-input
              disabled
              v-model="ruleForm.place.money"
              placeholder="请输入租金单价"
              ><template slot="append">元/h</template></el-input
            >
          </el-form-item>
          <el-form-item label="场地标签">
            <el-input disabled v-model="ruleForm.place.devices"></el-input>
          </el-form-item>
          <el-form-item label="场地图片">
            <el-image
              v-for="(img, ind) in ruleForm.place.thumb"
              :key="ind"
              style="width: 120px; height: 40px; margin: 0 5px 5px 0"
              :src="imageOss + img"
              fit="contain"
              :preview-src-list="$pathDispose(ruleForm.place.thumb)"
            >
            </el-image>
          </el-form-item>
        </div>
      </el-form>
    </el-drawer>

    <!-- <el-dialog
      title="审批"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-form-item
          label="审核"
          prop="status"
          :rules="[
            { required: true, message: '请选择审核', trigger: 'change' },
          ]"
        >
          <el-radio-group v-model="form.status">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="reason" label="驳回意见" v-if="form.status == 2">
          <el-input type="textarea" v-model="form.reason"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('form')"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { openPark, openCompany, openAgoUser, adminUser } from "@/api/index";
import {
  gardenApplyList,
  gardenApplyOperation,
  gardenApplyInfo,
} from "@/api/smartFarm";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      list: [],
      listLoading: true,
      statusList: [
        {
          title: "待审核",
          id: 1,
        },
        {
          title: "审核通过",
          id: 2,
        },
        {
          title: "审核失败",
          id: 3,
        },
      ],
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
        user_id: "",
        audit_user_id: "",
        status: "",
        audit_time: [],
        phone: "",
        name: "",
      },
      total: 0,
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      dialogVisible: false,
      form: {
        id: "",
        status: "",
        reason: "",
      },
      rules: {
        status: [{ required: true, message: "请选择审核", trigger: "change" }],
        reason: [
          { required: true, message: "请输入驳回意见", trigger: "blur" },
        ],
      },
      companyList: [],
      userList: [],
      drawer: false,
      ruleForm: {},
      adminUserList: [],
      gardenList: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
      this.screenParkChange(this.userInfo.park_id);
      this.getAdminUser(this.userInfo.park_id);
    } else {
      this.screen.park_id = "";
      this.getAdminUser();
    }
    // this.getCompany();
    // this.getUser();

    this.fetchData();
    this.getPark();
  },
  methods: {
    getGarden(id) {},
    screenParkChange(e) {
      this.getUser(e);
    },
    getUser(e) {
      openAgoUser({ park_id: e, is_youke: 2 }).then((res) => {
        this.userList = res.data.lists.data;
      });
    },
    operation(id, val) {
      var that = this;
      let title = "";
      if (val == 2) {
        title = "确定预约？";
        this.$prompt("请输入种植内容", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputValidator: (value) => {
            if (!value) {
              return "种植内容不能为空";
            }
          }, //非空验证
        })
          .then(({ value }) => {
            gardenApplyOperation({ id: id, status: val, species: value }).then(
              (res) => {
                if (res.code == 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                }
                that.fetchData();
              }
            );
          })
          .catch(() => {});
      } else if (val == 3) {
        this.$confirm("确定审核失败？")
          .then(() => {
            gardenApplyOperation({ id: id, status: val, species: null }).then(
              (res) => {
                if (res.code == 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                }
                that.fetchData();
              }
            );
          })
          .catch(() => {});
      }
    },
    // 查看详情
    getInfo(id) {
      var that = this;
      gardenApplyInfo({ id: id }).then((res) => {
        that.ruleForm = res.data;
        that.drawer = true;
      });
    },
    // 获取后台用户列表
    getAdminUser(id) {
      adminUser({ park_id: id }).then((response) => {
        this.adminUserList = response.data.lists.data;
      });
    },
    // 获取企业
    getCompany(park_id = "") {
      openCompany({ is_page: 2, park_id: park_id }).then((response) => {
        this.companyList = response.data.lists;
      });
    },
    reset() {
      this.screen = {
        park_id: "",
        page: 1,
        page_size: 15,
        user_id: "",
        audit_user_id: "",
        status: "",
        audit_time: [],
        phone: "",
        name: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      let audit_time = [];
      if (this.screen.audit_time.length > 0) {
        this.screen.audit_time.forEach((element) => {
          audit_time.push(element / 1000);
        });
      }

      let data = {
        page: this.screen.page,
        page_size: this.screen.page_size,
        phone: this.screen.phone,
        park_id: this.screen.park_id,
        name: this.screen.name,
        status: this.screen.status,
        user_id: this.screen.user_id,
        audit_user_id: this.screen.audit_user_id,
        audit_time: audit_time.toString(),
      };

      gardenApplyList(data).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}

.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
  .screenInput {
    width: 200px;
    margin-right: 10px;
    margin-bottom: 5px;
  }
}
</style>
